'use strict';

export default class SettingsController {
  user = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  errors = {
    other: undefined
  };

  submitted = false;

  passwordChangeSuccess = false;

  /*@ngInject*/
  constructor(Auth, Config, IntegrationService) {
    this.Auth = Auth;
    this.IntegrationService = IntegrationService;
    this.Auth.getCurrentUser(user => this.user = user);
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
  }

  changePassword(form) {
    this.submitted = true;
    this.passwordChangeSuccess = false;

    if(form.$valid) {

      if (this.user.provider === 'ldap-conduu-ms-webaccess') { // ------------------------------------------------------

        this.IntegrationService.suiteChangePasswordWebAccess({webaccessId: this.user.webaccessId}, {
            oldPassword: this.user.oldPassword,
            newPassword: this.user.newPassword
          },
          _ => {
            this.passwordChangeSuccess = true;
          },
          err => {
            form.password.$setValidity('mongoose', false);
            this.errors.other = 'Incorrect password';
          });

      } else { // provider == 'local' ----------------------------------------------------------------------------------

        this.Auth.changePassword(this.user.oldPassword, this.user.newPassword)
          .then(() => {
            this.passwordChangeSuccess = true;
          })
          .catch(() => {
            form.password.$setValidity('mongoose', false);
            this.errors.other = 'Incorrect password';
          });
      }

    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/change-password/change-password.controller.js